import { action, computed, makeObservable, observable } from 'mobx';
import { loadable } from '@fulcrumgt/mobx-store-utils';
import BaseStore from './base.store';
import { RootStore } from './root.store';
import { Report } from '../api/types/types';

export default class ReportsStore extends BaseStore {
    sessionAPI = this.rootStore.api.SupersetSession;
    reportAPI = this.rootStore.api.Report;
    @observable currentReportId: string = '';
    @observable reports: Report[] = [];
    @observable searchInput: string = '';

    constructor(root: RootStore) {
        super(root);
        makeObservable(this);
    }

    @computed get filteredReportsByCategory() {
        let res: { [key: string]: Array<Report> } = {};
        let unCategorized: Report[] = [];
        this.reports.forEach((d) => {
            if (d.name.toLowerCase().includes(this.searchInput.toLowerCase())) {
                if (d.category) {
                    res[d.category] = (res[d.category] || []).concat(d);
                } else {
                    unCategorized.push(d);
                }
            }
        });
        if (unCategorized.length > 0) {
            res[''] = unCategorized;
        }
        return res;
    }
    
    @action.bound
    setSearchInput(value: string) {
        this.searchInput = value;
    }

    @action.bound
    setReport(id: string) {
        this.currentReportId = id;
    }

    @action.bound
    async initializeSession() {
        this.sessionAPI.initialize();
    }

    @loadable()
    @action.bound
    async fetchGuestToken() {
        let response = await this.sessionAPI.axios.post('/security/guest_token/', {
            resources: [
                {
                    id: this.currentReportId,
                    type: 'dashboard'
                }
            ],
            user: {
                first_name: 'API',
                last_name: 'USER',
                username: 'api_user'
            },
            rls: []
        });

        return response.data.token;
    }

    @loadable('fetchingReports')
    @action.bound
    async fetchReports() {
        this.reports = await this.reportAPI.all();
    }

    @action.bound
    clearStore() {
        this.currentReportId = '';
        this.searchInput = '';
        this.reports = [];
    }
}
